import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d3b6795"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "open-menu",
  viewBox: "0 0 100 80",
  width: "25",
  height: "25"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  width: "100",
  height: "20"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  y: "30",
  width: "100",
  height: "20"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  y: "60",
  width: "100",
  height: "20"
}, null, -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  class: "close-menu",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Plans", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, "About", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Contact", -1))
const _hoisted_14 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderBar',
  setup(__props) {

const isShow = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "hamburger-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isShow.value = !isShow.value))
      }, [
        _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_6, 512)), [
          [_vShow, isShow.value == false]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9, 512)), [
          [_vShow, isShow.value == true]
        ])
      ]),
      _createElementVNode("nav", {
        class: _normalizeClass([{ active: isShow.value }, "navigation-list"])
      }, _hoisted_14, 2)
    ])
  ]))
}
}

})